import { useGetData } from 'src/hooks/useGetData'
import userApi from 'src/api/userApi'
import { Tag } from 'antd'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

const TYPE_STUDENT = {
  NEW: 'NEW',
  CHANGE_CLASS: 'CHANGE_CLASS',
  LAST_SESSION: 'LAST_SESSION'
}

export function TagNewStudent ({ studentId, sessionId }) {
  const {t} = useTranslation()

  const payload = useMemo(() => {
    if(!studentId || !sessionId) return null
    return {studentId, sessionId}
  }, [studentId, sessionId])
  const { data } = useGetData(userApi.getStatusStudentInSession, payload, { isDisabled: !payload })

  if (!data?.length) return null
  return data.map(o => {
    switch(o?.type) {
      case TYPE_STUDENT.NEW:
        return <Tag className='rounded' color="#87d068">{t('common.text.session')} {o?.numberSession}</Tag>
      case TYPE_STUDENT.CHANGE_CLASS:
        return <Tag className='rounded' color="#ffbc54">{t('common.text.change_class')}</Tag>
      case TYPE_STUDENT.LAST_SESSION:
        return <Tag className='rounded' color="red">{t('common.text.late_session')}</Tag>
      default: 
        return null
    }
  })
  
}
